<template>
  <highcharts :options="chartOptions" />
</template>

<script>
import { Chart } from 'highcharts-vue';

const getChartOptions = (component) => {
  let size = 100;
  if (component.chartData && Object.keys(component.chartData).length > 0) {
    if (component.windowWidth < 1200) {
      size = 160;
    } else if (component.windowWidth < 1550) {
      size = 90;
    } else size = 125;
  }
  const commonOptions = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      className: 'donut-with-legend',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: `<span class=" v2_font_size_18">${component.chartTitle}</span>`,
      useHTML: true,
    },
    legend: {
      align: 'right',
      verticalAlign: 'top',
      layout: 'vertical',
      itemMarginTop: 10,
      itemMarginBottom: 10,
      x: 0,
      y: 20,
      symbolHeight: 25,
      symbolWidth: 25,
      symbolRadius: 0,
      width: '40%',
      titleItemClass: 'some',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
        center: [null, 60],
        size: size,
      },
    },
    series: [
      {
        name: 'Composition',
        colorByPoint: true,
        innerSize: '60%',
        data: component.chartData,
      },
    ],
  };

  return {
    ...commonOptions,
  };
};

export default {
  name: 'InfoDonutWithLegend',
  components: {
    highcharts: Chart,
  },
  props: {
    chartData: Array,
    chartTitle: String,
  },
  data: function () {
    return {
      chartOptions: null,
    };
  },
  created() {
    this.chartOptions = getChartOptions(this);
  },
  watch: {
    windowWidth: function () {
      this.chartOptions = getChartOptions(this);
    },
  },
};
</script>

<style lang="scss">
.donut-with-legend {
  .highcharts-legend-item.highcharts-pie-series {
    & > span {
      top: 5px !important;
    }
  }
  .highcharts-legend-item {
    tspan {
      font-size: 14px;
      font-weight: normal;
    }
  }
}
</style>
